// Not exported by the DLS kit. Verified theme-neutral: both footers compute
// identically under republicLegacy and the DLS theme, so the theme switch is a
// no-op here.
// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import { DrawerFooter, ModalFooter } from '@chakra-ui/react';
import {
  Box,
  Button,
  ButtonGroup,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
} from '@joinrepublic/dls-ui-kit';

import { IRegionSwitcherSettings } from './types';

export interface IRegionSwitcherDialogProps {
  variant: 'modal' | 'drawer';
  targetRegion?: string | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (variantId: string) => void;
  regionalSwitcherSettings: IRegionSwitcherSettings;
}

export const RegionSwitcherDialog = ({
  variant,
  targetRegion,
  isOpen,
  onClose,
  onConfirm,
  regionalSwitcherSettings,
}: IRegionSwitcherDialogProps) => {
  const variants = regionalSwitcherSettings.variants;

  const { name } = variants.find((v) => v.id === targetRegion) ?? variants[0];

  const content = (
    <Box>
      <Heading size="title-md" my="4">
        Change region to {name}?
      </Heading>
      <Text size="body-md" variant="text-primary">
        You will be redirected to the {name} site. You may need to create a new
        account on the {name} site to&nbsp;invest.
      </Text>
    </Box>
  );

  const controls = (
    <ButtonGroup>
      <Button
        variant="primary"
        size="lg"
        onClick={() => {
          if (targetRegion) {
            onConfirm(targetRegion);
          }
          onClose();
        }}
      >
        Yes, continue
      </Button>

      <Button
        variant={variant === 'modal' ? 'secondary' : 'naked'}
        size="lg"
        minW="40"
        onClick={onClose}
      >
        No
      </Button>
    </ButtonGroup>
  );

  return variant === 'modal' ? (
    <Modal onClose={onClose} isOpen={isOpen} size="sm" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>{content}</ModalBody>
        <ModalFooter justifyContent="start">{controls}</ModalFooter>
      </ModalContent>
    </Modal>
  ) : (
    <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerBody>{content}</DrawerBody>
        <DrawerFooter justifyContent="start">{controls}</DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
